import { Button, Form, Input, Select, Space, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';

interface GrupoData {
    id: number;
    descripcion: string;
    clasificacion: number;
  }
  

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const CrearInsumos: React.FC = () => {
  const {user} = useAuth0();
  const empresa = user?.id_empresa;
  const [form] = Form.useForm();
  const [buttonLoading, setButtonLoading] = useState(false);
  const { getAccessTokenSilently , isLoading} = useAuth0();
  const [marcas, setMarcas] = useState<GrupoData[]>([]);
  const [grupos, setGrupos] = useState<GrupoData[]>([]);
  const [subgrupos, setSubgrupos] = useState<GrupoData[]>([]);
  const [loadingMarcas, setLoadingMarcas] = useState(false);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const [loadingSubGrupos, setLoadingSubGrupos] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  // Función para cargar las marcas
  const fetchMarcas = async () => {
    setInitialLoading(true);
    setLoadingMarcas(true);
    setLoadingGrupos(true);
    setLoadingSubGrupos(true);
    try {
      const accessToken = await getAccessTokenSilently();
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_objetos/${empresa}`, {
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Error al cargar las marcas');
      }

      const data = await response.json();
      // Filtrar solo los registros con clasificacion = 3 (Marca)
      const soloMarcas = data.filter((item: GrupoData) => item.clasificacion === 3);
      const soloGrupos = data.filter((item: GrupoData) => item.clasificacion === 1);
      const soloSubGrupos = data.filter((item: GrupoData) => item.clasificacion === 2);
      setMarcas(soloMarcas);
      setGrupos(soloGrupos);
      setSubgrupos(soloSubGrupos);
    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar los datos iniciales');
    } finally {
      setInitialLoading(false);
      setLoadingMarcas(false);
      setLoadingGrupos(false);
      setLoadingSubGrupos(false);
    }
  };

  // Cargar las marcas cuando el componente se monta
  useEffect(() => {
    fetchMarcas();
  }, []);

  const handleAdd = () => {
    setButtonLoading(true);
    form.validateFields().then(async (values) => {
      try {
        const accessToken = await getAccessTokenSilently();
        const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/crear_insumos`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            ...values,
            id_empresa: empresa, // Asume que tienes un ID de empresa, ajusta según sea necesario
          /*  tipo: values.tipo*/
          }),
        });
        if (!response.ok) {
          
          throw new Error('Network response was not ok');
        }
        message.success('Insumo añadido correctamente');
        form.resetFields();
      } catch (error) {
        console.error('Error adding insumo:', error);
        message.error(`Error al añadir el insumo:${error}`);
      } finally {
        setButtonLoading(false);
      }
    });
  };



  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Spin spinning={initialLoading} tip="Cargando datos...">
      <Form
        {...layout}
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{ 
          maxWidth: 600,
          margin: '0 auto',
          padding: '2rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <Form.Item name="codbarra" label="Codigo de barra" rules={[{ required: true }]}>
          <Input maxLength={19} showCount />
        </Form.Item>
        <Form.Item name="descripcion" label="Descripcion" rules={[{ required: true }]}>
          <Input maxLength={40} showCount />
        </Form.Item>
        <Form.Item name="stockminimo" label="Stock minimo" rules={[{ required: false }]}>
          <Input />
        </Form.Item>   
        <Form.Item name="ubicacion" label="Ubicacion Deposito"  rules={[{ required: false }]}>
          <Input maxLength={7} showCount />
        </Form.Item>
        <Form.Item name="unidad" label="Unidad de medida"  rules={[{ required: true }]}>
          <Input maxLength={5} showCount />
        </Form.Item>       
        <Form.Item name="tasaiva" label="Tasa de IVA" rules={[{ required: true }]}>
          <Select placeholder="Seleccione una opción">
            <Select.Option value={21}>21%</Select.Option>
            <Select.Option value={10.5}>10.5%</Select.Option>
            <Select.Option value={27}>27%</Select.Option>
            <Select.Option value={0}>0%</Select.Option>
          </Select>  
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => prevValues.tasaiva !== currentValues.tasaiva}
        >
        </Form.Item>
        <Form.Item 
          name="id_grupo" 
          label="Grupo" 
          rules={[{ required: true, message: 'Por favor seleccione un grupo' }]}
        >
          <Select
            placeholder="Seleccione un grupo"
            loading={loadingGrupos}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {grupos.map(grupo => (
              <Select.Option key={grupo.id} value={grupo.id}>
                {grupo.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="id_subgrupo" 
          label="Subgrupo" 
          rules={[{ required: true, message: 'Por favor seleccione un subgrupo' }]}
        >
          <Select
            placeholder="Seleccione un subgrupo"
            loading={loadingSubGrupos}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {subgrupos.map(subgrupo => (
              <Select.Option key={subgrupo.id} value={subgrupo.id}>
                {subgrupo.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item 
          name="id_marca" 
          label="Marca" 
          rules={[{ required: true, message: 'Por favor seleccione una marca' }]}
        >
          <Select
            placeholder="Seleccione una marca"
            loading={loadingMarcas}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {marcas.map(marca => (
              <Select.Option key={marca.id} value={marca.id}>
                {marca.descripcion}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Space>
            <Button 
            type="primary" 
            htmlType="submit"
            onClick={handleAdd}          
            loading={buttonLoading}
            disabled={buttonLoading}
            >
              {buttonLoading ? 'Guardando...' : 'Guardar'}
            </Button>
            <Button type="default"><Link to= {`/listar_insumos`}>
              Listar
            </Link>
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default CrearInsumos;